// Called by : src/components/question/Question.vue (answer-scq)

<template>
  <base-modal ref="base-modal" pageId="answer_scq" pageClass="answer" modalClass="modal-lg" modalDataBack="true" modalDataKey="true" :key="keyModal">
    
    {{ forceUpdate }}

    <template #header>
      <h2 id="answer_scq_title" class="modal-title " :class="getClassTitle()">
        <sound-player :url="question.audioQuestion" role="answerQuestion" tone="btn-outline-warning mr-3"></sound-player>
        <span v-html="questionQuestion"></span>
        <!-- {{ questionQuestion }} -->
      </h2>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    
    <template #body>
      <div class="answer_props text-left">
        <div class="form_radio my-2" v-for="proposal in question.props" :key="proposal.index">
          <label class="form_radio_label text-wrap" :class="getClassLabel(proposal.audioTitle)" :for="proposal.index">
            <sound-player :url="proposal.audioTitle" role="answerProposal" tone="btn-outline-secondary mr-4"></sound-player>
            <input class="form_radio_input" type="radio" :id="proposal.index" v-model="answer" :value="proposal.zkp">
            <span class="form_radio_icon"><b></b></span>
            <span v-html="getProp(proposal.prop)"></span>
          </label>
        </div>
      </div>
    </template>
    
    <template #footer>
      <button type="submit" class="btn_modal_submit btn btn-primary btn-lg btn-block" :disabled="getDisabled()" @click.stop="save">
        <span class="oi oi-check mr-2"></span>
        {{ $t('modals.validate') }}
      </button>
    </template>
    
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal'
import SoundPlayer from '@/components/misc/SoundPlayer'

export default {
  components: {
    BaseModal,
    SoundPlayer,
  },
  props: {
    question: Object,
    isfr: Boolean,
  },
  data() {
    return {
      questionQuestion: '',
      langFr: true,
      answer: '',
      keyModal: false,
    }
  },
  methods: {
    save() {
      // console.log('save method', this.answer)
      var sAnswer = this.answer;
      this.answer = '';
      $('#answer_scq').modal('hide');
      this.$emit('save', sAnswer);
    },
    getClassTitle() {
      return { 'answer_scq_title': this.question.audioQuestion }
    },
    getClassLabel(sPropTitle) {
      return { 'form_radio_label_audio': sPropTitle }
    },
    getDisabled() {
      // console.log('AnswerScq',this.answer);
      let bOff = !this.answer;
      f_setModalBtnOff_v(bOff);
      return bOff;
    },
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    getProp(sProp) {
      if (this.langFr) return f_setCleanSpacesFr_s(sProp);
      return sProp;
    },
  },
  computed: {
    forceUpdate() {
      // this.langFr = Boolean(this.lesson.lang.toLowerCase() === "fr");
      this.questionQuestion = (this.isfr) ? f_setCleanSpacesFr_s(this.question.question) : this.question.question;
      if (!this.keyModal) this.keyModal = this.getKey('ModalScq');
      return '';
    },
    lesson() {
      return this.$store.state.lesson
    },
  },
  mounted: function() {
    this.answer = '';
    this.keyModal = false;
  },
}
</script>

<style scoped>
h2.answer_scq_title {
  padding-left: 56px !important;
  text-indent: -56px !important;
}
label.form_radio_label {
  color: #000;
  cursor: pointer;
  position: relative;
  font-size: 1.8rem;
  line-height: 1.2em;
  padding-left: 44px;
  text-indent: -44px;
}
label.form_radio_label_audio {
  padding-left: 104px;
  text-indent: -112px;
}
input.form_radio_input {
  display: none;
}
span.form_radio_icon,
span.form_radio_icon > b {
  display: inline-block;
  box-sizing: border-box;
  border-radius: 50%;
  cursor: pointer;
}
span.form_radio_icon {
  width: 34px;
  height: 34px;
  margin: 0 0.25rem 0 0;
  border: 5px solid #888;
  background-color: #fff;
  position: relative;
  top: 0.5rem;
  text-indent: 0;
}
span.form_radio_icon > b {
  width: 24px;
  height: 24px;
  border: 5px solid #fff;
  background-color: #fff;
  position: absolute;
  top: 0;
}
label.form_radio_label:hover > span.form_radio_icon,
span.form_radio_icon:hover {
  box-shadow: 2px 2px 4px #bbb;
}
label.form_radio_label:active > span.form_radio_icon,
span.form_radio_icon:active {
  border-color: #000;
  box-shadow: none;
}
label.form_radio_label:hover > span.form_radio_icon > b,
span.form_radio_icon:hover > b,
span.form_radio_icon > b:hover {
  background-color: #06c;
  opacity: 0.5;
}
label.form_radio_label:active > span.form_radio_icon > b,
span.form_radio_icon:active > b,
span.form_radio_icon > b:active {
  background-color: #06c;
  opacity: 1;
}
input.form_radio_input:checked + span.form_radio_icon {
  border-color: #06c;
  box-shadow: none;
}
input.form_radio_input:checked + span.form_radio_icon > b {
  background-color: #06c;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/question/AnswerScq.vue